<template>
  <div class="fs" data-test="form-settings">
    <SettingsCard title="Form">
      <FieldRow
        label="Form"
        :note="noForms ? 'No forms found. Create forms in the Forms module first.' : ''"
        note-tone="amber"
      >
        <WfPicker
          v-model="p.formObj"
          :options="wfBuilder.formsList"
          :searchable="true"
          :show-labels="false"
          label="Name"
          track-by="FormID"
          placeholder="Choose a form…"
          @input="(val) => p.formId = val ? val.FormID : ''"
        />
      </FieldRow>

      <FieldRow label="Patients" :choice="true">
        <label class="fs__choice" :class="{ 'is-on': p.newPatientOnly }">
          <input v-model="p.newPatientOnly" type="checkbox" data-test="form-new-patient-only" />
          <span class="fs__choice-label">Send only to new patients</span>
        </label>
      </FieldRow>
    </SettingsCard>

    <SettingsCard title="Delivery" description="Select how you want to send the form link to the patient.">
      <FieldRow label="Send by" :choice="true">
        <div class="fs__choices">
          <label class="fs__choice" :class="{ 'is-on': p.sendViaEmail }">
            <input v-model="p.sendViaEmail" type="checkbox" data-test="form-send-email" />
            <span class="fs__choice-label">Email</span>
          </label>
          <label class="fs__choice" :class="{ 'is-on': p.sendViaSms }">
            <input v-model="p.sendViaSms" type="checkbox" data-test="form-send-sms" />
            <span class="fs__choice-label">Text message</span>
          </label>
        </div>
      </FieldRow>

      <FieldRow v-if="p.sendViaEmail" label="Send email when">
        <WfPicker
          v-model="p.emailSendWhenObj"
          :options="wfBuilder.smsSendOptions"
          :searchable="false"
          :show-labels="false"
          label="text"
          track-by="value"
          placeholder="Select when…"
          @input="(val) => p.emailSendWhen = val ? val.value : 'immediately'"
        />
      </FieldRow>

      <FieldRow v-if="p.sendViaSms" label="Send text when">
        <WfPicker
          v-model="p.smsSendWhenObj"
          :options="wfBuilder.smsSendOptions"
          :searchable="false"
          :show-labels="false"
          label="text"
          track-by="value"
          placeholder="Select when…"
          @input="(val) => p.smsSendWhen = val ? val.value : 'immediately'"
        />
      </FieldRow>
    </SettingsCard>
  </div>
</template>

<script>
/**
 * Send a form (design frame 1l): the form, "only new patients", and how and when the link goes out. The
 * classic fields and side effects: `formObj` / `formId`, `newPatientOnly`, `sendViaEmail` / `sendViaSms`,
 * `emailSendWhenObj` / `emailSendWhen`, `smsSendWhenObj` / `smsSendWhen` (both timing lists are classic's
 * `smsSendOptions`, as in the classic template).
 *
 * ⛔ No prop named patNum / siteID / loading / allSettings / isSuperAdmin / userID.
 */
import FieldRow from './FieldRow.vue';
import SettingsCard from './SettingsCard.vue';
import WfPicker from './WfPicker.vue';

export default {
  name: 'FormSettings',
  components: { FieldRow, SettingsCard, WfPicker },
  inject: ['wfBuilder'],

  computed: {
    p() {
      return (this.wfBuilder.selectedNodeData || {}).properties || {};
    },
    noForms() {
      return (this.wfBuilder.formsList || []).length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../workflow-tokens';

.fs {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fs__choices {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (max-width: 620px) { grid-template-columns: 1fr; }
}

.fs__choice {
  @include wf-choice-card;
  align-items: center;
  margin: 0;
}

.fs__choice-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  color: $fu-text;
}
</style>
